module.exports = __webpack_public_path__ + "static/media/Logo__Microsoft.be755be3.svg";